import {
  LIBRARY_CATEGORIES_PAGE_REQUEST,
  LIBRARY_CATEGORIES_LIST_REQUEST,
  LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS,
  LIBRARY_CATEGORIES_ON_CLICK_ROW,
  LIBRARY_CATEGORIES_ON_CLICK_CANCEL,
  LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE,
  LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY,
  LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE,
  LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
  LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST,
  LIBRARY_CATEGORIES_DELETE_CATEGORY,
  LIBRARY_CATEGORIES_CANCEL_DELETE,
  LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST,
  LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM
} from 'actions/library/category/constants'
import {takeLatest, put, call} from 'redux-saga/effects'
import {initialize, change} from 'redux-form'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as actCategory from 'actions/library/category'
import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiCategory from 'api/categories'
import * as apiItems from 'api/items'
import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpLibraryCategory from 'mixpanel/library/category'

const CATEGORY_SUCCESSFULLY_CREATED_MESSAGE = 'Category successfully created.'

function * fillSearchFormFromProfile (profile) {
  let assignedOutletIds = []
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {'outletIds': assignedOutletIds}
  yield put(initialize('search', data))
}

function * fillFormCategoryDetail (category) {
  let formCategoryDetail = {
    id: category.id,
    name: category.name
  }
  yield put(initialize('category', formCategoryDetail))
}

function * openRightColumn () {
  yield put(actCategory.openRightColumn())
}

function * closeRightColumn () {
  yield put(actCategory.closeRightColumn())
}

function * fillFormAssignToItemFlow (request) {
  const {payload: {category}} = request
  let form = {
    id: category.id,
    itemIds: category.items && category.items.map((itemCategory) => {
      return itemCategory.id
    })
  }
  yield put(initialize('assignToItem', form))
}

export function * categoriesPageRequestFlow () {
  yield put(actCategory.setListCategories([]))
  yield put(showPageLoadingSpinner(true))
  yield put(actCategory.setOutlets([]))
  yield put(act.showProgressBar())
  yield put(actCategory.setCategoryDetail(null))
  yield put(actCategory.closeRightColumn())
  try {
    let response = yield call(apiOutlets.outlets)
    yield put(actCategory.setOutlets(response.data))

    let profile = yield call(apiProfile.getProfile)
    yield call(fillSearchFormFromProfile, profile.data)
    mpLibraryCategory.libraryCategoryStart({currentOutlet: profile.data.outlet_id[0]})
    yield put(actCategory.categoriesRequest({with_items: true, page: 1}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * categoriesRequestFlow (request) {
  let {payload: {params, previousCategories}} = request
  try {
    yield put(act.showProgressBar())
    if (params && params.keyword) {
      let response = yield call(apiCategory.getCategoriesV1, params)
      let categories = response.data
      yield put(actCategory.setListCategories(categories))
      yield put(actCategory.setTotalPage(1))
      yield put(actCategory.setCurrentPage(1))
    } else {
      let resCategories = yield call(apiCategory.getCategories, {with_items: true, page: params.page})
      let categories
      if (previousCategories) {
        categories = previousCategories.concat(resCategories.data.results)
      } else {
        categories = resCategories.data.results
      }
      yield put(actCategory.setListCategories(categories))
      yield put(actCategory.setTotalPage(resCategories.data.total_pages))
      yield put(actCategory.setCurrentPage(params.page))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * onChangeOutletIds (action) {
  yield put(actCategory.setListCategories([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds}} = action
  mpLibraryCategory.libraryCategoryChangeOutlet({currentOutlet: outletIds})
  try {
    yield put(actCategory.setCategoryDetail(null))
    yield call(closeRightColumn)
    yield call(fillFormCategoryDetail, {id: null, name: null})
    yield put(act.showProgressBar())
    yield call(apiOutlets.patchLogin, {id: outletIds})
    yield put(actCategory.categoriesRequest({with_items: true, page: 1}))
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onClickRowFlow (request) {
  let {payload: {category}} = request
  try {
    yield put(act.showProgressBar())
    let categoryDetail = yield call(apiCategory.getCategoryDetail, category.id)
    yield put(actCategory.setCategoryDetail(categoryDetail.data))
    yield call(fillFormCategoryDetail, categoryDetail.data)
    yield call(openRightColumn)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onClickCancelFlow () {
  yield put(actCategory.setCategoryDetail(null))
  yield call(fillFormCategoryDetail, {id: null, name: null})
  yield call(closeRightColumn)
}

export function * updateCategoryFlow (request) {
  let {payload: {id, data, previousCategories}} = request
  let keyword = data.name
  let type = 'edit'
  let oldCategoryName = null
  previousCategories.forEach(category => {
    if (category.id === id) oldCategoryName = category.name
  })
  mpLibraryCategory.libraryCategoryUpdateOneOutlet({oldName: oldCategoryName, newName: data.name})
  try {
    yield put(act.showProgressBar())
    yield put(actCategory.isSubmittingForm(true))
    yield call(apiCategory.categoryRequestWithKeywordAndType, {keyword: keyword, type: type})
    let response = yield call(apiCategory.updateCategory, id, data)
    let categoryData = response.data
    const categories = []
    let categoryExisted = false
    previousCategories.forEach(category => {
      if (category.id === id) {
        categories.push(categoryData)
      } else {
        if (keyword !== category.name) {
          categories.push(category)
        } else {
          categoryExisted = true
        }
      }
    })
    if (categoryExisted) {
      yield put(actNotif.error('The name of the Category must be unique'))
    } else {
      yield put(actNotif.success('Category was successfully updated.'))
      yield put(actCategory.setListCategories(categories))
      yield put(actCategory.setCategoryDetail(categoryData))
      yield call(fillFormCategoryDetail, categoryData)
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actCategory.isSubmittingForm(false))
  }
}

export function * onClickCreateCategoryFlow () {
  yield put(actCategory.setCategoryDetail(null))
  yield call(fillFormCategoryDetail, {id: null, name: null})
  yield call(openRightColumn)
}

export function * createCategoryFlow (request) {
  let {payload: {data, previousCategories}} = request
  let keyword = data.name
  let type = 'new'
  try {
    yield put(act.showProgressBar())
    yield put(actCategory.isSubmittingForm(true))
    yield call(apiCategory.categoryRequestWithKeywordAndType, {keyword: keyword, type: type})
    let response = yield call(apiCategory.createCategory, data)
    let categoryData = response.data
    let categoryExist = false
    const categories = [categoryData]
    previousCategories.forEach(category => {
      if (keyword !== category.name) {
        categories.push(category)
      } else {
        categoryExist = true
      }
    })
    if (categoryExist) {
      yield put(actNotif.error('The name of the Category must be unique'))
    } else {
      yield put(actNotif.success(CATEGORY_SUCCESSFULLY_CREATED_MESSAGE))
      yield put(actCategory.setListCategories(categories))
      yield put(actCategory.setCategoryDetail(categoryData))
      yield call(fillFormCategoryDetail, categoryData)
    }
  } catch (error) {
    yield put(actNotif.error('Failed to create category.'))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actCategory.isSubmittingForm(false))
  }
}

export function * createCategoryAllOutletsFlow (request) {
  let {payload: {data, previousCategories}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actCategory.isSubmittingForm(true))
    let response = yield call(apiCategory.createCategoryAllOutlets, data)
    let categoryData = response.data
    const categories = [categoryData]
    previousCategories.forEach(category => {
      categories.push(category)
    })
    yield put(actNotif.success(CATEGORY_SUCCESSFULLY_CREATED_MESSAGE))
    yield put(actCategory.setListCategories(categories))
    yield put(actCategory.setCategoryDetail(categoryData))
    yield call(fillFormCategoryDetail, categoryData)
  } catch (error) {
    yield put(actNotif.error('Failed to save category to all outlets'))
  } finally {
    yield put(actCategory.isSubmittingForm(false))
    yield put(act.hideProgressBar())
  }
}

export function * deleteCategoryRequest (request) {
  const {payload: {deletedCategory}} = request
  yield put(actCategory.setDeletedCategory(deletedCategory))
  yield put(actCategory.showDeleteModal())
}

export function * deleteCategoryFlow (request) {
  let {payload: {id, previousCategories}} = request
  try {
    yield put(act.showProgressBar())
    yield call(apiCategory.deleteCategory, id)
    let categories = []
    previousCategories.forEach((category) => {
      if (category.id !== id) {
        categories.push(category)
      }
    })
    yield put(actCategory.setListCategories(categories))
    yield put(actCategory.setCategoryDetail(null))
    yield put(actCategory.setDeletedCategory(null))
    yield put(actCategory.hideDeleteModal())
    yield call(closeRightColumn)
    yield put(actNotif.success('Category was successfully removed.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * cancelDeleteCategoryFlow () {
  yield put(actCategory.setDeletedCategory(null))
  yield put(actCategory.hideDeleteModal())
}

export function * onClickAssignToItemFlow (request) {
  const {payload: {category}} = request
  yield put(act.showProgressBar())
  try {
    let resItems = yield call(apiItems.getItems, {})
    let items = resItems.data
    yield put(actCategory.assignToItemFillForm(category))
    yield put(actCategory.assignToItemSetCurrentPage(1))
    yield put(actCategory.assignToItemSetTotalPage(items.total_pages))
    yield put(actCategory.assignToItemSetItems(items.results))
    yield put(actCategory.showAssignToItemModal())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * cancelAssignToItemFlow () {
  yield put(actCategory.hideAssignToItemModal())
}

export function * assignToItemGetItemsRequestFlow (request) {
  const {payload: {params, previousItems}} = request
  try {
    yield put(act.showProgressBar())
    if (params && params.keyword) {
      // V1 API includes params with_batch to support pagination
      params.with_batch = true
      const resItems = yield call(apiItems.getItemsV1, params)
      yield put(actCategory.assignToItemSetCurrentPage(1))
      yield put(actCategory.assignToItemSetTotalPage(1))
      let items = resItems.data.results
      yield put(actCategory.assignToItemSetItems(items))
    } else {
      const resItems = yield call(apiItems.getItems, params)
      yield put(actCategory.assignToItemSetCurrentPage(params.page))
      yield put(actCategory.assignToItemSetTotalPage(resItems.data.total_pages))
      let items = previousItems.concat(resItems.data.results)
      yield put(actCategory.assignToItemSetItems(items))
    }
    yield put(actCategory.showAssignToItemModal())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * submitAssignToItemFlow (request) {
  const {payload: {data, categoryId}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actCategory.hideAssignToItemModal())
    yield call(apiCategory.assignToItem, categoryId, data)
    yield put(actCategory.setCategoryDetail(null))
    yield call(closeRightColumn)
    let resCategories = yield call(apiCategory.getCategories, {with_items: true, page: 1})
    let categories = resCategories.data.results
    yield put(actCategory.setListCategories(categories))
    yield put(actCategory.setTotalPage(resCategories.data.total_pages))
    yield put(actCategory.setCurrentPage(1))
    yield put(actNotif.success('Successfully move selected items.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export default function * saga () {
  yield takeLatest(LIBRARY_CATEGORIES_PAGE_REQUEST, categoriesPageRequestFlow)
  yield takeLatest(LIBRARY_CATEGORIES_LIST_REQUEST, categoriesRequestFlow)
  yield takeLatest(LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS, onChangeOutletIds)
  yield takeLatest(LIBRARY_CATEGORIES_ON_CLICK_ROW, onClickRowFlow)
  yield takeLatest(LIBRARY_CATEGORIES_ON_CLICK_CANCEL, onClickCancelFlow)
  yield takeLatest(LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE, updateCategoryFlow)
  yield takeLatest(LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE, createCategoryFlow)
  yield takeLatest(LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY, onClickCreateCategoryFlow)
  yield takeLatest(LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS, createCategoryAllOutletsFlow)
  yield takeLatest(LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST, deleteCategoryRequest)
  yield takeLatest(LIBRARY_CATEGORIES_DELETE_CATEGORY, deleteCategoryFlow)
  yield takeLatest(LIBRARY_CATEGORIES_CANCEL_DELETE, cancelDeleteCategoryFlow)
  yield takeLatest(LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM, onClickAssignToItemFlow)
  yield takeLatest(LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM, cancelAssignToItemFlow)
  yield takeLatest(LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM, submitAssignToItemFlow)
  yield takeLatest(LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM, fillFormAssignToItemFlow)
  yield takeLatest(LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST, assignToItemGetItemsRequestFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/library/category.js